import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { groupBy } from 'lodash';
import classNames from 'classnames';
import useScreen from 'hooks/useScreen';
import Placeholder from 'components/consumer/Placeholder';
import PDPActiveFabric from 'components/consumer/PDP/PDPActiveFabric';
import PDPDecideLaterPromo from 'components/consumer/PDP/PDPDecideLaterPromo';
import PDPUpholsterySortBy from 'components/consumer/PDP/PDPUpholsterySortBy';
import MaterialThumbnailGroup from 'components/consumer/MaterialThumbnailGroup';
import PDPUpholsteryFilters from 'components/consumer/PDP/PDPUpholsteryFilters';
import PDPFabricDetailSidebar from 'components/consumer/PDP/PDPFabricDetailSidebar';
import PDPFreeSwatchKitButton from 'components/consumer/PDP/PDPFreeSwatchKitButton';
import PDPOrderSwatchesSidebar from 'components/consumer/PDP/PDPOrderSwatchesSidebar';
import PDPUpholsteryColorFilters from 'components/consumer/PDP/PDPUpholsteryColorFilters';
import { PDP_CUSTOMIZE_TAB_ID, PDP_READYTOSHIP_TAB_ID, PDP_DECIDELATER_TAB_ID, FABRIC_PRODUCT_OPTION_ID, LEATHER_PRODUCT_OPTION_ID, GRADE_NUMERAL_BY_VALUE, PDP_NAMED_FILTERS, PANTONE_FABRIC_CONFIG } from 'commons/constants';
import { materialPropType, productFilterTypes } from 'types/PDPTypes';
import useFabricDetails from 'data-hooks/useFabricDetails';
import useIsTouchDevice from 'hooks/useIsTouchDevice';
import usePdpIsModularBYOProduct from 'components/consumer/PDP/state/context/usePdpIsModularBYOProduct';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useProjectResetConfig from 'data-hooks/useProjectResetConfig';
import MaterialThumbnailGroupPlaceholder from 'components/consumer/MaterialThumbnailGroup/MaterialThumbnailGroupPlaceholder';
import FlyoutContainer from '../../FlyoutContainer';
import PDPSelectUpholsteryDecideLater from './PDPSelectUpholsteryDecideLater';
const {
  pantoneFabricSkus
} = PANTONE_FABRIC_CONFIG;
const tiers = {
  1: {
    title: 'Tier 1',
    desc: 'Readily available fabrics that bring an eye-catching look to your piece at a great value.'
  },
  2: {
    title: 'Tier 2',
    desc: 'Kick things up a notch with fabrics that show off more rich colors, textures, and durability.'
  },
  3: {
    title: 'Tier 3',
    desc: 'Got an active home? Check out these fabrics that showcase top notch performance finishes while still looking stylish.'
  },
  4: {
    title: 'Tier 4',
    desc: 'As luxe as it gets, this tier includes our branded performance fabrics and stain resistant finish fabrics, ready to take on all life throws its way in sophisticated style.'
  }
};
const NUMBER_OF_SWATCHES_PER_ROW_ON_DESKTOP = 9;
const MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON = 3 * NUMBER_OF_SWATCHES_PER_ROW_ON_DESKTOP;
const SORT_BY_OPTIONS = {
  POPULARITY: 'popularity',
  FAMILY: 'family',
  TIER: 'tier'
};
const moveMaterialToSecondPosition = (materials, materialSku) => {
  if (materials?.length && materialSku && materials[0]?.sku !== materialSku) {
    const filteredMaterials = materials.filter(({
      sku
    }) => sku !== materialSku);
    const material = materials.find(({
      sku
    }) => sku === materialSku);
    const [firstMaterial, ...restMaterials] = filteredMaterials;
    return [firstMaterial, material, ...restMaterials];
  }
  return materials;
};
const PDPSelectUpholsteryUI = t0 => {
  const $ = _c(136);
  const {
    activeColorFilters,
    activeNamedFilters,
    allMaterialsLength,
    clearAllFilters,
    disabledMaterialIds,
    fabricFavProps,
    filterCounts: t1,
    flashSaleOptionIds: t2,
    isClearanceFabricAvailable,
    isEditOrder: t3,
    isSelectedOptionsQuickship,
    loading,
    materials,
    mode: t4,
    onMoreMaterialsClick,
    onOptionValueHover,
    onOptionValueSelection,
    selectedMaterial,
    selectedOptionsStockQty,
    toggleColorFilter,
    toggleNamedFilter,
    upholsteryFilteredEvent,
    upholsteryOptionId,
    upholsteryOptionName
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const filterCounts = t5;
  let t6;
  if ($[2] !== t2) {
    t6 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const flashSaleOptionIds = t6;
  const isEditOrder = t3 === undefined ? false : t3;
  const mode = t4 === undefined ? "pdp" : t4;
  const {
    isDesktop,
    isMobile
  } = useScreen();
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const [selectedSortOption, setSelectedSortOption] = useState(SORT_BY_OPTIONS.POPULARITY);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const [isOrderSwatchesSidebarOpen, setIsOrderSwatchesSidebarOpen] = useState(false);
  const [galleryType, setGalleryType] = useState("");
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {};
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const [sortByFlyOutContent, setSortByFlyOutContent] = useState(t7);
  const [isSortByFlyOutVisible, setIsSortByFlyOutVisible] = useState(false);
  const {
    data: t8
  } = useFabricDetails(selectedMaterial?.materialId);
  const {
    selectedFabric
  } = t8;
  const isTouchDevice = useIsTouchDevice();
  const isPdpMode = mode === "pdp";
  const isLeather = upholsteryOptionId === LEATHER_PRODUCT_OPTION_ID;
  const tierOrGradeLabel = isLeather ? "Grade" : "Tier";
  let t9;
  if ($[5] !== materials || $[6] !== selectedSortOption) {
    t9 = selectedSortOption === SORT_BY_OPTIONS.FAMILY ? groupBy(materials, "groupName") : {};
    $[5] = materials;
    $[6] = selectedSortOption;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const materialsGroupedByFamily = t9;
  let t10;
  if ($[8] !== isLeather || $[9] !== materials || $[10] !== selectedSortOption) {
    t10 = selectedSortOption === SORT_BY_OPTIONS.TIER ? groupBy(materials, isLeather ? "grade" : SORT_BY_OPTIONS.TIER) : {};
    $[8] = isLeather;
    $[9] = materials;
    $[10] = selectedSortOption;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const materialsGroupedByTier = t10;
  const isQuickview = mode === "quickview";
  const quickviewNumberOfFabricsToShow = isMobile ? 5 : 8;
  const limitNumberShownForQuickview = isQuickview && allMaterialsLength > quickviewNumberOfFabricsToShow;
  const {
    data: projectResetConfig
  } = useProjectResetConfig();
  let t11;
  if ($[12] !== projectResetConfig) {
    t11 = projectResetConfig ?? {};
    $[12] = projectResetConfig;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const {
    isProjectResetEnabled,
    projectResetNewFabricSkus
  } = t11;
  let t12;
  bb0: {
    let t13;
    if ($[14] !== isProjectResetEnabled || $[15] !== isQuickview || $[16] !== materials || $[17] !== projectResetNewFabricSkus?.[0]) {
      t13 = isQuickview ? moveMaterialToSecondPosition(materials, isProjectResetEnabled ? projectResetNewFabricSkus?.[0] : pantoneFabricSkus?.[0]) : materials;
      $[14] = isProjectResetEnabled;
      $[15] = isQuickview;
      $[16] = materials;
      $[17] = projectResetNewFabricSkus?.[0];
      $[18] = t13;
    } else {
      t13 = $[18];
    }
    const materialsPantoneFabricAsSecond = t13;
    if (limitNumberShownForQuickview) {
      let t14;
      if ($[19] !== materialsPantoneFabricAsSecond || $[20] !== quickviewNumberOfFabricsToShow) {
        t14 = materialsPantoneFabricAsSecond.slice(0, quickviewNumberOfFabricsToShow);
        $[19] = materialsPantoneFabricAsSecond;
        $[20] = quickviewNumberOfFabricsToShow;
        $[21] = t14;
      } else {
        t14 = $[21];
      }
      t12 = t14;
      break bb0;
    }
    t12 = materialsPantoneFabricAsSecond;
  }
  const ungroupedMaterialsArray = t12;
  const moreMaterialsCount = limitNumberShownForQuickview ? allMaterialsLength - quickviewNumberOfFabricsToShow : undefined;
  const ungroupedMaterialsLength = ungroupedMaterialsArray?.length ?? 0;
  const [hasShowAllFabricsButtonBeenClicked, setHasShowAllFabricsButtonBeenClicked] = useState(false);
  const isAllFabricsShown = !activeNamedFilters.length;
  const showShowAllFabricsButton = isDesktop && isAllFabricsShown && !loading && !hasShowAllFabricsButtonBeenClicked && ungroupedMaterialsLength > MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON;
  let t13;
  if ($[22] !== showShowAllFabricsButton || $[23] !== ungroupedMaterialsArray) {
    t13 = showShowAllFabricsButton ? ungroupedMaterialsArray.slice(0, MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON) : ungroupedMaterialsArray;
    $[22] = showShowAllFabricsButton;
    $[23] = ungroupedMaterialsArray;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const ungroupedMaterialsToShow = t13;
  let t14;
  if ($[25] !== isTouchDevice) {
    t14 = upholsteryOptionNameVal => {
      const tapOrClick = isTouchDevice ? "tap" : "click";
      return upholsteryOptionNameVal === "Fabric" ? `Double-${tapOrClick} a fabric to add to your favorites` : upholsteryOptionNameVal === "Leather" ? `Double-${tapOrClick} a leather to add to your favorites` : "Double tap to favorite";
    };
    $[25] = isTouchDevice;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const getFabricFavInfoToShow = t14;
  const noActiveNamedFilters = !activeNamedFilters.length;
  const noActiveColorFilters = activeColorFilters.length === 0;
  const noActiveFilters = noActiveNamedFilters && noActiveColorFilters;
  const t15 = !noActiveFilters;
  let t16;
  if ($[27] !== noActiveFilters || $[28] !== t15) {
    t16 = classNames("text-xs font-bold p-[5px] underline", {
      "text-gray-light4 pointer-events-none": noActiveFilters,
      "text-red hover:text-red-dark": t15
    });
    $[27] = noActiveFilters;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== clearAllFilters || $[31] !== noActiveFilters) {
    t17 = () => {
      if (!noActiveFilters) {
        clearAllFilters();
      }
    };
    $[30] = clearAllFilters;
    $[31] = noActiveFilters;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t16 || $[34] !== t17) {
    t18 = <button type="button" data-xc="PDPClearAllFiltersButton" className={t16} onClick={t17}>Clear All</button>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  const clearAllFiltersButton = t18;
  let t19;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = (content, isVisible) => {
      setSortByFlyOutContent(content);
      setIsSortByFlyOutVisible(isVisible);
    };
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  const onToggleFlyOut = t19;
  let t20;
  if ($[37] !== isSortByFlyOutVisible || $[38] !== sortByFlyOutContent) {
    t20 = isSortByFlyOutVisible && <FlyoutContainer top={sortByFlyOutContent.top > 300 ? sortByFlyOutContent.top - 300 : sortByFlyOutContent.top} title={sortByFlyOutContent.title} content={sortByFlyOutContent.content} subTitle={sortByFlyOutContent.subTitle} imageUrl={sortByFlyOutContent.imageUrl} titleInfo={sortByFlyOutContent.titleInfo} titleExtra={sortByFlyOutContent.titleExtra} subSubTitle={sortByFlyOutContent.subSubTitle} onClose={() => setIsSortByFlyOutVisible(false)} isOpen={isSortByFlyOutVisible} />;
    $[37] = isSortByFlyOutVisible;
    $[38] = sortByFlyOutContent;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  const flyoutContainerContent = t20;
  let t21;
  if ($[40] !== disabledMaterialIds || $[41] !== fabricFavProps || $[42] !== flashSaleOptionIds || $[43] !== isEditOrder || $[44] !== materialsGroupedByFamily || $[45] !== onOptionValueHover || $[46] !== onOptionValueSelection || $[47] !== pdpIsModularBYOProduct || $[48] !== selectedMaterial || $[49] !== upholsteryOptionId) {
    t21 = Object.keys(materialsGroupedByFamily).sort().map(groupName => <div key={groupName} className="mb-8"><div className="text-sm font-bold text-gray">{groupName}</div><MaterialThumbnailGroup disabledMaterialIds={disabledMaterialIds} fabricFavProps={fabricFavProps} flashSaleOptionIds={flashSaleOptionIds} isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} materials={materialsGroupedByFamily[groupName]} onClick={onOptionValueSelection} onHover={onOptionValueHover} onToggleFlyOut={onToggleFlyOut} optionId={upholsteryOptionId} selectedMaterial={selectedMaterial} /></div>);
    $[40] = disabledMaterialIds;
    $[41] = fabricFavProps;
    $[42] = flashSaleOptionIds;
    $[43] = isEditOrder;
    $[44] = materialsGroupedByFamily;
    $[45] = onOptionValueHover;
    $[46] = onOptionValueSelection;
    $[47] = pdpIsModularBYOProduct;
    $[48] = selectedMaterial;
    $[49] = upholsteryOptionId;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t21) {
    t22 = <div className="p-6 max-h-[472px] overflow-y-auto bg-gray-light9 border border-solid border-gray-light7">{t21}</div>;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  const sortByFamilyMaterialThumbnails = t22;
  let t23;
  if ($[53] !== disabledMaterialIds || $[54] !== fabricFavProps || $[55] !== flashSaleOptionIds || $[56] !== isEditOrder || $[57] !== isLeather || $[58] !== materialsGroupedByTier || $[59] !== onOptionValueHover || $[60] !== onOptionValueSelection || $[61] !== pdpIsModularBYOProduct || $[62] !== selectedMaterial || $[63] !== tierOrGradeLabel || $[64] !== upholsteryOptionId) {
    t23 = Object.keys(materialsGroupedByTier).filter(_temp).sort(_temp2).map(tierId_0 => {
      const gradeNumeral = GRADE_NUMERAL_BY_VALUE[tierId_0] || String(tierId_0);
      const tierMeta = isLeather ? {
        title: `${tierOrGradeLabel} ${gradeNumeral}`,
        desc: ""
      } : tiers[tierId_0];
      return tierMeta ? <div key={tierId_0} className="mt-8"><div className="text-sm font-bold text-gray">{tierMeta.title}</div>{tierMeta.desc ? <div className="text-xs text-gray mb-[1.2rem]">{tierMeta.desc}</div> : <div className="mb-[1.2rem]" />}<MaterialThumbnailGroup disabledMaterialIds={disabledMaterialIds} fabricFavProps={fabricFavProps} flashSaleOptionIds={flashSaleOptionIds} isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} materials={materialsGroupedByTier[tierId_0]} onClick={onOptionValueSelection} onHover={onOptionValueHover} optionId={upholsteryOptionId} selectedMaterial={selectedMaterial} /></div> : null;
    });
    $[53] = disabledMaterialIds;
    $[54] = fabricFavProps;
    $[55] = flashSaleOptionIds;
    $[56] = isEditOrder;
    $[57] = isLeather;
    $[58] = materialsGroupedByTier;
    $[59] = onOptionValueHover;
    $[60] = onOptionValueSelection;
    $[61] = pdpIsModularBYOProduct;
    $[62] = selectedMaterial;
    $[63] = tierOrGradeLabel;
    $[64] = upholsteryOptionId;
    $[65] = t23;
  } else {
    t23 = $[65];
  }
  let t24;
  if ($[66] !== t23) {
    t24 = <div>{t23}</div>;
    $[66] = t23;
    $[67] = t24;
  } else {
    t24 = $[67];
  }
  const sortByTierMaterialThumbnails = t24;
  let t25;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = () => {
      setGalleryType("");
      setSidebarOpen(false);
    };
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  const onCloseCallback = t25;
  const materialThumbnailVariant = mode === "quickview" ? "PDPSelectUpholsteryUI--quickview" : "PDPSelectUpholsteryUI";
  const t26 = mode !== "quickview";
  let t27;
  if ($[69] !== t26) {
    t27 = classNames("relative", {
      "[border-bottom:1px_solid_#e5e5e5] mb-2 pb-8": t26
    });
    $[69] = t26;
    $[70] = t27;
  } else {
    t27 = $[70];
  }
  let t28;
  if ($[71] !== pdpSelectedCustomizerTab) {
    t28 = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID ? <PDPSelectUpholsteryDecideLater /> : null;
    $[71] = pdpSelectedCustomizerTab;
    $[72] = t28;
  } else {
    t28 = $[72];
  }
  let t29;
  if ($[73] !== activeColorFilters || $[74] !== activeNamedFilters || $[75] !== isMobile || $[76] !== mode || $[77] !== selectedSortOption || $[78] !== toggleColorFilter || $[79] !== upholsteryFilteredEvent || $[80] !== upholsteryOptionId) {
    t29 = mode !== "quickview" && upholsteryOptionId === FABRIC_PRODUCT_OPTION_ID && !isMobile ? <div className="items-center flex justify-between w-full mb-4"><h4 className="text-base font-bold">Filter by color:</h4><PDPUpholsteryColorFilters activeColorFilters={activeColorFilters} toggleColorFilter={updatedColor => {
        toggleColorFilter(updatedColor);
        upholsteryFilteredEvent(activeNamedFilters, updatedColor, selectedSortOption);
      }} /></div> : <div />;
    $[73] = activeColorFilters;
    $[74] = activeNamedFilters;
    $[75] = isMobile;
    $[76] = mode;
    $[77] = selectedSortOption;
    $[78] = toggleColorFilter;
    $[79] = upholsteryFilteredEvent;
    $[80] = upholsteryOptionId;
    $[81] = t29;
  } else {
    t29 = $[81];
  }
  let t30;
  if ($[82] !== activeColorFilters || $[83] !== activeNamedFilters || $[84] !== clearAllFiltersButton || $[85] !== disabledMaterialIds || $[86] !== fabricFavProps || $[87] !== filterCounts || $[88] !== flashSaleOptionIds || $[89] !== flyoutContainerContent || $[90] !== getFabricFavInfoToShow || $[91] !== isClearanceFabricAvailable || $[92] !== isDesktop || $[93] !== isEditOrder || $[94] !== isLeather || $[95] !== isMobile || $[96] !== isOrderSwatchesSidebarOpen || $[97] !== isPdpMode || $[98] !== isSelectedOptionsQuickship || $[99] !== loading || $[100] !== materialThumbnailVariant || $[101] !== mode || $[102] !== moreMaterialsCount || $[103] !== onMoreMaterialsClick || $[104] !== onOptionValueHover || $[105] !== onOptionValueSelection || $[106] !== pdpIsModularBYOProduct || $[107] !== pdpSelectedCustomizerTab || $[108] !== selectedFabric || $[109] !== selectedMaterial || $[110] !== selectedOptionsStockQty || $[111] !== selectedSortOption || $[112] !== showShowAllFabricsButton || $[113] !== sortByFamilyMaterialThumbnails || $[114] !== sortByTierMaterialThumbnails || $[115] !== toggleColorFilter || $[116] !== toggleNamedFilter || $[117] !== ungroupedMaterialsArray || $[118] !== ungroupedMaterialsToShow || $[119] !== upholsteryFilteredEvent || $[120] !== upholsteryOptionId || $[121] !== upholsteryOptionName) {
    t30 = pdpSelectedCustomizerTab === PDP_CUSTOMIZE_TAB_ID || pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID ? <div>{!!isPdpMode && pdpSelectedCustomizerTab === PDP_CUSTOMIZE_TAB_ID ? upholsteryOptionName === "Leather" ? <div className="text-sm -mt-8 mx-0 mb-8 font-bold">{getFabricFavInfoToShow("Leather")}</div> : <>{isMobile && <div className="flex justify-between my-1"><h4 className="text-base font-bold">Filter by color</h4>{clearAllFiltersButton}</div>}<div className="mt-0 mx-0 space-y-2 max-[1023px]:-ml-10 max-[1023px]:-mr-5 [&::-webkit-scrollbar]:max-[1023px]:hidden max-[1023px]:pb-6">{isMobile && <PDPUpholsteryColorFilters activeColorFilters={activeColorFilters} showRowInMobile={true} toggleColorFilter={color => {
            toggleColorFilter(color);
            upholsteryFilteredEvent(activeNamedFilters, color, selectedSortOption);
          }} showMobileColorFilter={true} />}<PDPUpholsteryFilters clearAllFiltersButton={clearAllFiltersButton} filtersCollectionVisible={activeNamedFilters} setFiltersCollectionVisible={updatedFilterType => {
            toggleNamedFilter(updatedFilterType);
            upholsteryFilteredEvent(updatedFilterType, activeColorFilters, selectedSortOption);
          }} filterCounts={filterCounts} loading={loading} showFabricFavs={!!fabricFavProps.actions.setOptionAsFav} isClearanceFabricAvailable={isClearanceFabricAvailable} fabricFavInfoToShow={activeNamedFilters.length === 1 && activeNamedFilters[0] === PDP_NAMED_FILTERS.FAVORITES ? getFabricFavInfoToShow(upholsteryOptionName) : ""} variant="PDPSelectUpholstery" />{!loading && ungroupedMaterialsArray.length === 0 && <span className="text-xs font-bold text-gray">Try removing a filter to see more fabric options</span>}</div></> : <div />}{mode !== "quickview" && (upholsteryOptionId === FABRIC_PRODUCT_OPTION_ID || upholsteryOptionId === LEATHER_PRODUCT_OPTION_ID) && <div className="hidden sm:block"><PDPUpholsterySortBy isLeather={isLeather} selectedOption={selectedSortOption} setSelectedOption={updatedSortOption => {
          setSelectedSortOption(updatedSortOption);
          upholsteryFilteredEvent(activeNamedFilters, activeColorFilters, updatedSortOption);
        }} /></div>}<div className="flex flex-row justify-between"><PDPActiveFabric isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} isSelectedOptionsQuickship={pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID && isSelectedOptionsQuickship} loading={loading} onClick={() => {
          setGalleryType("FabricMultiImg");
          setSidebarOpen(true);
        }} selectedOption={selectedMaterial} selectedOptionsStockQty={selectedOptionsStockQty} size={mode === "quickview" ? "xs" : undefined} showInfoIcon={!!selectedFabric} />{!!isPdpMode && pdpSelectedCustomizerTab !== PDP_READYTOSHIP_TAB_ID && !isEditOrder ? loading ? <Placeholder type="rect" loading={true} style={{
          height: "43px",
          width: "152px",
          borderRadius: "43px"
        }} /> : <div className="mb-2"><PDPFreeSwatchKitButton styling="rainbow-button" onClick={() => {
            setIsOrderSwatchesSidebarOpen(true);
          }} /><PDPOrderSwatchesSidebar show={isOrderSwatchesSidebarOpen} onClose={() => {
            setIsOrderSwatchesSidebarOpen(false);
          }} closeSlidePanel={() => {
            setIsOrderSwatchesSidebarOpen(false);
          }} /></div> : <div />}</div>{selectedSortOption === SORT_BY_OPTIONS.FAMILY ? <>{flyoutContainerContent}{sortByFamilyMaterialThumbnails}</> : selectedSortOption === SORT_BY_OPTIONS.TIER ? sortByTierMaterialThumbnails : <div data-xc="PDPFabricSwatches" className={classNames("max-[1023px]:-ml-5 max-[1023px]:-mr-5 max-[1023px]:md:ml-[-3.333vw] max-[1023px]:md:mr-[-3.333vw]", {
        "max-[1023px]:md:!m-0": mode === "quickview"
      })}>{loading ? <MaterialThumbnailGroupPlaceholder variant={materialThumbnailVariant} /> : <MaterialThumbnailGroup disabledMaterialIds={disabledMaterialIds} enableFlyout={mode === "pdp"} fabricFavProps={fabricFavProps} flashSaleOptionIds={flashSaleOptionIds} isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} materials={ungroupedMaterialsToShow} moreMaterialsCount={moreMaterialsCount} onClick={onOptionValueSelection} onHover={onOptionValueHover} onMoreMaterialsClick={onMoreMaterialsClick} optionId={upholsteryOptionId} selectedMaterial={selectedMaterial} showMoreMaterialsOnDesktop={mode === "quickview"} variant={materialThumbnailVariant} />}{showShowAllFabricsButton && <div className="relative pt-6 mt-[-52px] bg-white bg-opacity-70"><div className="bg-white px-[6px]"><CtaButton block={true} color="brand" onClick={() => {
              setHasShowAllFabricsButtonBeenClicked(true);
            }} spacing="sm" styling="outline-button">Show All Fabrics</CtaButton></div></div>}</div>}{!!isPdpMode && pdpSelectedCustomizerTab !== PDP_READYTOSHIP_TAB_ID && !isEditOrder && isDesktop ? <div className="mt-4 mx-0 mb-0"><PDPDecideLaterPromo /></div> : <div />}</div> : <div />;
    $[82] = activeColorFilters;
    $[83] = activeNamedFilters;
    $[84] = clearAllFiltersButton;
    $[85] = disabledMaterialIds;
    $[86] = fabricFavProps;
    $[87] = filterCounts;
    $[88] = flashSaleOptionIds;
    $[89] = flyoutContainerContent;
    $[90] = getFabricFavInfoToShow;
    $[91] = isClearanceFabricAvailable;
    $[92] = isDesktop;
    $[93] = isEditOrder;
    $[94] = isLeather;
    $[95] = isMobile;
    $[96] = isOrderSwatchesSidebarOpen;
    $[97] = isPdpMode;
    $[98] = isSelectedOptionsQuickship;
    $[99] = loading;
    $[100] = materialThumbnailVariant;
    $[101] = mode;
    $[102] = moreMaterialsCount;
    $[103] = onMoreMaterialsClick;
    $[104] = onOptionValueHover;
    $[105] = onOptionValueSelection;
    $[106] = pdpIsModularBYOProduct;
    $[107] = pdpSelectedCustomizerTab;
    $[108] = selectedFabric;
    $[109] = selectedMaterial;
    $[110] = selectedOptionsStockQty;
    $[111] = selectedSortOption;
    $[112] = showShowAllFabricsButton;
    $[113] = sortByFamilyMaterialThumbnails;
    $[114] = sortByTierMaterialThumbnails;
    $[115] = toggleColorFilter;
    $[116] = toggleNamedFilter;
    $[117] = ungroupedMaterialsArray;
    $[118] = ungroupedMaterialsToShow;
    $[119] = upholsteryFilteredEvent;
    $[120] = upholsteryOptionId;
    $[121] = upholsteryOptionName;
    $[122] = t30;
  } else {
    t30 = $[122];
  }
  let t31;
  if ($[123] !== t28 || $[124] !== t29 || $[125] !== t30) {
    t31 = <div>{t28}{t29}{t30}</div>;
    $[123] = t28;
    $[124] = t29;
    $[125] = t30;
    $[126] = t31;
  } else {
    t31 = $[126];
  }
  const t32 = !!selectedMaterial?.materialId && isSidebarOpen;
  const t33 = selectedMaterial?.materialId;
  let t34;
  if ($[127] !== galleryType || $[128] !== mode || $[129] !== t32 || $[130] !== t33) {
    t34 = <PDPFabricDetailSidebar isOpen={t32} onClose={onCloseCallback} fabricId={t33} mode={mode} galleryType={galleryType} mobileHideHeader={true} />;
    $[127] = galleryType;
    $[128] = mode;
    $[129] = t32;
    $[130] = t33;
    $[131] = t34;
  } else {
    t34 = $[131];
  }
  let t35;
  if ($[132] !== t27 || $[133] !== t31 || $[134] !== t34) {
    t35 = <div className={t27}>{t31}{t34}</div>;
    $[132] = t27;
    $[133] = t31;
    $[134] = t34;
    $[135] = t35;
  } else {
    t35 = $[135];
  }
  return t35;
};
PDPSelectUpholsteryUI.propTypes = {
  activeNamedFilters: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  allMaterialsLength: PropTypes.number,
  disabledMaterialIds: PropTypes.arrayOf(PropTypes.number),
  fabricFavProps: PropTypes.object,
  filterCounts: productFilterTypes,
  flashSaleOptionIds: PropTypes.arrayOf(PropTypes.number),
  isClearanceFabricAvailable: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isSelectedOptionsQuickship: PropTypes.bool,
  loading: PropTypes.bool,
  materials: PropTypes.arrayOf(materialPropType),
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onMoreMaterialsClick: PropTypes.func,
  onOptionValueHover: PropTypes.func,
  onOptionValueSelection: PropTypes.func,
  activeColorFilters: PropTypes.array,
  selectedMaterial: materialPropType,
  selectedOptionsStockQty: PropTypes.number,
  toggleColorFilter: PropTypes.func,
  toggleNamedFilter: PropTypes.func,
  upholsteryFilteredEvent: PropTypes.func,
  upholsteryOptionId: PropTypes.number,
  upholsteryOptionName: PropTypes.string
};
export default PDPSelectUpholsteryUI;
function _temp(tierId) {
  return Number(tierId) > 0;
}
function _temp2(a, b) {
  return Number(a) - Number(b);
}